// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const apiUrl = `/v1/`;
let accessTokenGetter = null;

export function setAccessTokenGetter(getter) {
    accessTokenGetter = getter;
}

export async function prepareAuthorizationHeaders(headers) {
    try {
        const accessToken = accessTokenGetter ? await accessTokenGetter() : null;
        if (accessToken) {
            headers.set("Authorization", `Bearer ${accessToken}`);
        }
    } catch (error) { /* Don't do anything right now */ }

    return headers;
}

// Define a service using a base URL and expected endpoints
export const applianceMonitorApi = createApi({
    reducerPath: 'applianceMonitorApi',
    baseQuery: fetchBaseQuery({
        baseUrl: apiUrl,
        prepareHeaders: prepareAuthorizationHeaders,
    }),
    endpoints: (builder) => ({
        getConfig: builder.query({
            query: () => `config`,
            providesTags: ['Config']
        }),
        getDevices: builder.query({
            query: () => `device`,
            providesTags: ['Device']
        }),
        getActivityTypes: builder.query({
            query: () => `activity-types`,
            providesTags: ['ActivityType']
        }),
    }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useGetConfigQuery,
    useGetDevicesQuery,
    useGetActivityTypesQuery} = applianceMonitorApi
